import React from "react";
import classnames from "classnames";
import styles from "./ConfirmModal.module.scss";
import { BaseModal, IModalProps, ModalHeader } from "../";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@whatslly/ui-components/v2/Checkbox";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";

interface IConfirmModalProps extends IModalProps<{ result: boolean; dontShowAgain: boolean }> {
  title?: React.ReactNode;
  body?: React.ReactNode;
  bodyClassName?: string;
  okText?: string;
  cancelText?: string;
  askIfDontShowAgain?: { text?: React.ReactNode } | true;
  isSubmitDisabled?: boolean;
  modalType?: "confirm" | "warning";
}

export const ConfirmModal: React.FC<IConfirmModalProps> = (props) => {
  const { t } = useTranslation();
  const [dontShowAgain, setDontShowAgain] = React.useState(false);
  const dontShowAgainText = typeof props.askIfDontShowAgain !== "boolean" ? props.askIfDontShowAgain?.text : t("dont_show_again");

  return (
    <BaseModal
      {...props}
      closeModal={props.closeModal}
      className={classnames(styles.confirmModal, props.modalType && styles[props.modalType])}
      header={
        <ModalHeader closeModal={() => props.closeModal({ result: false, dontShowAgain })}>
          <div className={styles.title}>
            {props.modalType === "warning" && (
              <div className={styles.icon}>
                <SvgV2 iconName={"warning"} />
              </div>
            )}
            {props.title}
          </div>
        </ModalHeader>
      }
    >
      <div className={classnames(styles.body, props.bodyClassName)} data-testid="confirm-modal-body">
        {props.body}
        {props.children}
      </div>
      {props.askIfDontShowAgain && (
        <label className={styles.dontShowAgain}>
          <Checkbox value={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} />
          <span>{dontShowAgainText}</span>
        </label>
      )}
      <ModalButtons
        className={styles.buttons}
        isSubmitDisabled={props.isSubmitDisabled}
        testId="modal-buttons-submit-button"
        cancelText={props.cancelText}
        submitText={props.okText}
        onCancel={() => props.closeModal({ result: false, dontShowAgain })}
        onSubmit={() => props.closeModal({ result: true, dontShowAgain })}
      />
    </BaseModal>
  );
};
